import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_ARTICLE_ARTICLE,
    FAILURE_ARTICLE_ARTICLE_ASSIGNMENT,
    FAILURE_ARTICLE_ARTICLE_CUSTOM_FIELD,
    FAILURE_ARTICLE_ARTICLE_IMAGE,
    FAILURE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    FAILURE_ARTICLE_ARTICLE_PROPERTY,
    FAILURE_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP,
    FAILURE_DEACTIVATE_ARTICLE_ARTICLE,
    FAILURE_DELETE_ARTICLE_ARTICLE_ASSIGNMENT,
    FAILURE_DELETE_ARTICLE_ARTICLE_IMAGE,
    FAILURE_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    FAILURE_UPDATE_ARTICLE_ARTICLE,
    FAILURE_UPDATE_ARTICLE_ARTICLE_IMAGE,
    FAILURE_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    FAILURE_UPLOAD_ARTICLE_ARTICLE_IMAGE,
    REQUEST_ARTICLE_ARTICLE,
    REQUEST_ARTICLE_ARTICLE_ASSIGNMENT,
    REQUEST_ARTICLE_ARTICLE_CUSTOM_FIELD,
    REQUEST_ARTICLE_ARTICLE_IMAGE,
    REQUEST_ARTICLE_ARTICLE_PRODUCT_GROUP,
    REQUEST_ARTICLE_ARTICLE_PROPERTY,
    REQUEST_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP,
    REQUEST_DEACTIVATE_ARTICLE_ARTICLE,
    REQUEST_DELETE_ARTICLE_ARTICLE_ASSIGNMENT,
    REQUEST_DELETE_ARTICLE_ARTICLE_IMAGE,
    REQUEST_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    REQUEST_UPDATE_ARTICLE_ARTICLE,
    REQUEST_UPDATE_ARTICLE_ARTICLE_IMAGE,
    REQUEST_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    REQUEST_UPLOAD_ARTICLE_ARTICLE_IMAGE,
    SUCCESS_ARTICLE_ARTICLE,
    SUCCESS_ARTICLE_ARTICLE_ASSIGNMENT,
    SUCCESS_ARTICLE_ARTICLE_CUSTOM_FIELD,
    SUCCESS_ARTICLE_ARTICLE_IMAGE,
    SUCCESS_ARTICLE_ARTICLE_PRODUCT_GROUP,
    SUCCESS_ARTICLE_ARTICLE_PROPERTY,
    SUCCESS_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP,
    SUCCESS_DEACTIVATE_ARTICLE_ARTICLE,
    SUCCESS_DELETE_ARTICLE_ARTICLE_ASSIGNMENT,
    SUCCESS_DELETE_ARTICLE_ARTICLE_IMAGE,
    SUCCESS_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    SUCCESS_UPDATE_ARTICLE_ARTICLE,
    SUCCESS_UPDATE_ARTICLE_ARTICLE_IMAGE,
    SUCCESS_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP,
    SUCCESS_UPLOAD_ARTICLE_ARTICLE_IMAGE,
} from './actions';

export function articleArticleReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_UPDATE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DEACTIVATE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DEACTIVATE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_DEACTIVATE_ARTICLE_ARTICLE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function articleArticleAssignmentReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_ARTICLE_ASSIGNMENT:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_ARTICLE_ASSIGNMENT:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_ARTICLE_ASSIGNMENT:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_DELETE_ARTICLE_ARTICLE_ASSIGNMENT:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_ARTICLE_ARTICLE_ASSIGNMENT:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_DELETE_ARTICLE_ARTICLE_ASSIGNMENT:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function articleArticlePropertyReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_ARTICLE_PROPERTY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_ARTICLE_PROPERTY:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_ARTICLE_PROPERTY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function articleArticleCustomFieldReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_ARTICLE_CUSTOM_FIELD:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_ARTICLE_CUSTOM_FIELD:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_ARTICLE_CUSTOM_FIELD:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function articleArticleImagesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_UPLOAD_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPLOAD_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPLOAD_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DELETE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_DELETE_ARTICLE_ARTICLE_IMAGE:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function articleArticleProductGroupsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_CREATE_NEW_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_DELETE_ARTICLE_ARTICLE_PRODUCT_GROUP:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
